export const openApplicationMock = {
  navigatedFromAppId: 'itero-aohs',
  urlFrom: 'http://localhost:3400/home',
  navigatedToAppId: 'iosimplus',
  appMetadata: '{"orderId":12345678}',
};
